import { useEffect } from 'react';
import { useNavigate, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet';
import landingStyles from './landing.module.css';
import {ReactComponent as IconLogo} from '../../icons/logo_icontext.svg';
import FooterBar from '../../components/FooterBar';
import LandingDemo from './LandingDemo';
import { IS_DEV_FRONTEND } from '../../constants';


function LandingHeaderBar() {

  return (
    <header className={landingStyles.header}>
      <div className={landingStyles.headerLeft}>
        <IconLogo className={landingStyles.iconLogo}/>
      </div>
      <div className={landingStyles.headerMiddle}>
      </div>
      <div className={landingStyles.headerRight}>
        <NavLink to="/login">Sign In</NavLink>
        <NavLink to="/register" style={{display: 'contents'}}><button>Free Trial</button></NavLink>
      </div>
    </header>
  );
}

function AlertContainer() {
  return (
    <div className={landingStyles.alertContainer}>
      {IS_DEV_FRONTEND && <div className={landingStyles.alertBanner}><p>WARNING: This is the development version of LingoLeaf. You won't be able to log in unless you work here. Please visit the <a href="https://lingoleaf.io" rel="noopener noreferrer">real LingoLeaf</a> instead.</p></div>}
    </div>
  )
}





function Landing() {
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.user).isLoggedIn;

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/home');
    }
  }, [navigate, isLoggedIn]);

  return (
    <>
      <Helmet>
        <title>LingoLeaf</title>
        <meta name="description" content="LingoLeaf: Master languages through engaging graded short stories with translations, annotations, and comprehension questions. Start your language learning journey today." />
      </Helmet>
      <div className={landingStyles.container}>
        <LandingHeaderBar/>
        <main className={landingStyles.main}>
          <AlertContainer/>
          <div className={landingStyles.contentContainer}>
            <div className={landingStyles.textContainer}>
              <p><span className={landingStyles.banner}>Learn to read a new language.</span></p>
              <br/>
              <ul>
                <li><strong>Read short stories</strong> with annotations, translations, and comprehension questions.</li>
                <li><strong>New stories released regularly.</strong></li>
                <li><strong>Many supported languages.</strong></li>
                <li><strong>Three difficulty levels.</strong></li>
                <li><strong>Plant trees!</strong> 30% of LingoLeaf's profits go to tree-planting and conservation efforts.</li>
                <li><NavLink to='/faqs'><strong>Find out more</strong></NavLink> or <NavLink to='/register'><strong>sign up for a free trial</strong></NavLink></li>
              </ul>
            </div>
            <LandingDemo/>
          </div>
        </main>
        <FooterBar />
      </div>
    </>
  );
}

export default Landing;